import { AbstractControl } from '@angular/forms';
import { AddressForm } from '../03_current_contract_partner/model/occupied_contract_partner.model';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export interface ContractPartnerPrivateModel {
  birthDate: NgbDateStruct;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
}

export interface ContractPartnerPrivateForm {
  birthDate: AbstractControl<NgbDateStruct>;
  firstName: AbstractControl<string>;
  lastName: AbstractControl<string>;
  email: AbstractControl<string>;
  phone?: AbstractControl<string>;
}

export interface ContractPartnerCompanyModel {
  name: string;
  birthDate?: NgbDateStruct;
  uidNumber: string;
  firmenbuchNumber?: string;
  email: string;
  phone?: string;
}

export interface ContractPartnerCompanyForm {
  name: AbstractControl<string>;
  birthDate?: AbstractControl<NgbDateStruct>;
  uidNumber: AbstractControl<string>;
  firmenbuchNumber?: AbstractControl<string>;
  email: AbstractControl<string>;
  phone?: AbstractControl<string>;
}

export enum VertragspartnerSelectionType {
  EIGENES_UNTERNEHMEN,
  ALTERNATIVE_PARTNER,
}

export interface ContractPartnerEmpty {
  name: string;
  address: AddressForm;
  gpNr?: string;
  uid?: string;
  phone?: string;
  email?: string;
}

export const ALTERNATIVE_INVOICING_ADDRESS_KEY = 'newContractPartneralternativeInvoicingAddress';
